import type { ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

/** Einheitlicher Fehlerhinweis mit optionaler Wiederholung. */
export function AdminErrorNotice({
  title = "Daten konnten nicht geladen werden",
  message,
  action,
}: {
  title?: string;
  message?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div
      role="alert"
      className="rounded-lg border border-destructive/40 bg-destructive/10 p-4"
    >
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-destructive" aria-hidden="true" />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-foreground">{title}</p>
          {message ? (
            <p className="mt-1 break-words text-xs text-muted-foreground">{message}</p>
          ) : null}
          {action ? <div className="mt-3">{action}</div> : null}
        </div>
      </div>
    </div>
  );
}
